const VideoStatusEnum = {
    NO_VIDEO: 'no_video',
    LOADING: 'loading',
    READY: 'ready',
    PLAYING: 'playing'
}

export default VideoStatusEnum